module.exports = __webpack_public_path__ + "e3889c28d77cd0c15758bd5b34253159.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/fonts/ArialMT-Medium.ttf
// module id = 361
// module chunks = 1